
export default class IdleInterval {

  private thresholdMilliseconds: number;
  private timerId: number | null = null;
  private resetTimerFunction: () => any;

  constructor(thresholdMilliseconds: number, onThresholdCallback: () => any) {
    //console.log("Creating idle interval...");
    this.thresholdMilliseconds = thresholdMilliseconds;
    const reset = this.createResetTimer(onThresholdCallback);
    ['click', 'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach((eventName) => {
      document.addEventListener(eventName, reset, true);
    });
    reset();
    this.resetTimerFunction = reset;
  }

  public reset() {
    this.resetTimerFunction();
  }

  private createResetTimer(callback: () => any): () => any {
    return () => {
      if ( null != this.timerId ) {
        //console.log("  `--> clear timerId = " + this.timerId);
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        //console.log("firing callback");
        callback();
      } , this.thresholdMilliseconds);
      //console.log("  `--> new timerId = " + this.timerId);
    };
  }

}
